module.exports = __webpack_public_path__ + "media/images/diy/reservation_bg-84b26fba941489e25b2e87d225a04f3e.svg";